import script from "./IndOverviewSum.vue?vue&type=script&setup=true&lang=js"
export * from "./IndOverviewSum.vue?vue&type=script&setup=true&lang=js"

import "./IndOverviewSum.vue?vue&type=style&index=0&id=c25888ec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c25888ec"]])

export default __exports__